/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import {
  DialogFooter,
  // DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
// import { Switch } from "@/components/ui/switch";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";
// import { RetailerListInput } from "../user-input/retailer-list-input";

type UserFormType = {
  formData: any;
  onOpenChange: (prop: any) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  companyData: any;
};
export const ReactForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
}: UserFormType) => {
  const { form, onSubmit } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-x-6 gap-y-5 px-6">
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Name</FormLabel>
                <FormControl>
                  <Input
                    disabled={formData ? true : false}
                    placeholder="Enter workflow name"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="description"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Description</FormLabel>
                <FormControl>
                  <Input placeholder="Enter workflow description" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* <FormField
            control={form.control}
            name="is_new"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Is New</FormLabel>
                <FormControl>
                  <div className="pt-2">
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </div>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          /> */}
        </div>
        <hr className="mt-5" />
        <DialogFooter className="p-6 flex !justify-start">
          <Button
            type="submit"
            className="w-[160px]"
            disabled={form.formState.isSubmitting}
          >
            {form.formState.isSubmitting ? (
              <IconRender
                name="LoaderCircle"
                className="w-5 animate-spin text-white zoom-in-150"
              />
            ) : (
              "Save"
            )}
          </Button>
          <Button
            type="button"
            onClick={() => onOpenChange(false)}
            variant={"outline"}
            className="w-[160px]"
          >
            Close
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
};
